import styled from 'styled-components';

export const ContainerOneLine = styled('div')`
  width: 600px;
`;

export const ContainerCheckbox = styled('div')`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;
  width: 180px;
  gap: 10px;
  margin-bottom: 20px;
`;

export const Button = styled('div')`
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
  color: #ffffff;
  background-color: #0a77c7;
  border-radius: 8px;
  padding: 12px 24px;
  text-align: center;
  max-width: 170px;
  margin: 0 auto;
  margin-top: 20px;
`;
